// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ConsentAccessSetup: the credentials form inside the Consent category card (.br-sendto). The form is display: contents,
   so its labels, inputs and lines are rows of the card's own grid: they line up with the field above, and the form
   cannot widen the card's tracks the way a grid nested in it would (its long help line did). Labels, inputs, hint and
   error reuse the .br-sendto__* classes (index.css); this file places them and styles the actions row and the saved
   line that ConsentControl renders. One line per field keeps the form short in a 620px iframe. */

.br-consent-setup {
  display: contents;
}
/* The rule above the first row. */
.br-consent-setup::before {
  content: '';
  grid-column: 1 / -1;
  margin-top: 4px;
  border-top: 1px solid var(--br-rule);
}
/* The help line, the error and the buttons: a line of their own. */
.br-consent-setup__wide,
.br-consent-setup__actions {
  grid-column: 1 / -1;
}
.br-consent-setup__actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 4px;
}
.br-consent-setup__submit {
  height: var(--br-action-h);
  padding: 0 18px;
  border: 0;
  border-radius: var(--br-radius);
  background: var(--br-accent);
  color: #ffffff;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.br-consent-setup__submit:hover:not(:disabled) {
  background: var(--br-accent-hover);
}
.br-consent-setup__submit:focus-visible {
  outline: 2px solid var(--br-accent);
  outline-offset: 2px;
}
.br-consent-setup__submit:disabled,
.br-consent-setup .br-sendto__reset:disabled {
  opacity: 0.6;
  cursor: default;
}
.br-consent-setup .br-sendto__reset:disabled:hover {
  color: var(--br-accent);
  text-decoration: none;
}

/* The "Saved" line under the hint. It is always rendered, so a screen reader already has the live region when the
   text arrives; while empty it leaves the flow, so it adds no gap under the hint. */
.br-consent-setup__saved {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #1e6b42;
}
.br-consent-setup__saved:empty {
  position: absolute;
}

/* Wide enough for the card's three columns (its own breakpoint is 560px): the label beside its input, and the lines
   under the inputs, like the card's hint. Narrower, everything stacks in the card's single column. */
@media (min-width: 561px) {
  .br-consent-setup > .br-sendto__label {
    grid-column: 1;
  }
  .br-consent-setup > .br-sendto__input {
    grid-column: 2;
  }
  .br-consent-setup__wide,
  .br-consent-setup__actions {
    grid-column: 2 / -1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Message/ConsentAccessSetup.css"],"names":[],"mappings":"AAAA;;;;iGAIiG;;AAEjG;EACE,iBAAiB;AACnB;AACA,kCAAkC;AAClC;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,oCAAoC;AACtC;AACA,mEAAmE;AACnE;;EAEE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,SAAS;EACT,+BAA+B;EAC/B,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;oFACoF;AACpF;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;qGACqG;AACrG;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":["/* ConsentAccessSetup: the credentials form inside the Consent category card (.br-sendto). The form is display: contents,\n   so its labels, inputs and lines are rows of the card's own grid: they line up with the field above, and the form\n   cannot widen the card's tracks the way a grid nested in it would (its long help line did). Labels, inputs, hint and\n   error reuse the .br-sendto__* classes (index.css); this file places them and styles the actions row and the saved\n   line that ConsentControl renders. One line per field keeps the form short in a 620px iframe. */\n\n.br-consent-setup {\n  display: contents;\n}\n/* The rule above the first row. */\n.br-consent-setup::before {\n  content: '';\n  grid-column: 1 / -1;\n  margin-top: 4px;\n  border-top: 1px solid var(--br-rule);\n}\n/* The help line, the error and the buttons: a line of their own. */\n.br-consent-setup__wide,\n.br-consent-setup__actions {\n  grid-column: 1 / -1;\n}\n.br-consent-setup__actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 4px;\n}\n.br-consent-setup__submit {\n  height: var(--br-action-h);\n  padding: 0 18px;\n  border: 0;\n  border-radius: var(--br-radius);\n  background: var(--br-accent);\n  color: #ffffff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.br-consent-setup__submit:hover:not(:disabled) {\n  background: var(--br-accent-hover);\n}\n.br-consent-setup__submit:focus-visible {\n  outline: 2px solid var(--br-accent);\n  outline-offset: 2px;\n}\n.br-consent-setup__submit:disabled,\n.br-consent-setup .br-sendto__reset:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n.br-consent-setup .br-sendto__reset:disabled:hover {\n  color: var(--br-accent);\n  text-decoration: none;\n}\n\n/* The \"Saved\" line under the hint. It is always rendered, so a screen reader already has the live region when the\n   text arrives; while empty it leaves the flow, so it adds no gap under the hint. */\n.br-consent-setup__saved {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: #1e6b42;\n}\n.br-consent-setup__saved:empty {\n  position: absolute;\n}\n\n/* Wide enough for the card's three columns (its own breakpoint is 560px): the label beside its input, and the lines\n   under the inputs, like the card's hint. Narrower, everything stacks in the card's single column. */\n@media (min-width: 561px) {\n  .br-consent-setup > .br-sendto__label {\n    grid-column: 1;\n  }\n  .br-consent-setup > .br-sendto__input {\n    grid-column: 2;\n  }\n  .br-consent-setup__wide,\n  .br-consent-setup__actions {\n    grid-column: 2 / -1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
